import { Button } from "../Button";
import { ReactComponent as BackIcon } from "../../../assets/icons/flip-backward.svg";
import { navigate } from "@reach/router";

interface BackButtonProps {
	handleBackButtonClick: () => void;
	navigateTo?: string;
}

export const BackButton: React.FC<BackButtonProps> = ({
	handleBackButtonClick,
	navigateTo,
	...props
}) => {
	const handleButtonClick = () => {
		if (navigateTo) {
			return navigate(navigateTo);
		}

		if (window?.history?.state !== null) {
			return navigate("../");
		}

		return navigate(-1);
	};

	return (
		<Button
			btntype={"icon"}
			onClick={
				handleBackButtonClick ? handleBackButtonClick : handleButtonClick
			}
			{...props}
		>
			<BackIcon style={{ width: "28px", height: "28px", marginRight: "0px" }} />
		</Button>
	);
};
